import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import CommonFns from 'functions/common.ts';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ClearIcon from '@material-ui/icons/Clear';
import Switch from '@material-ui/core/Switch';
import * as MobileActions from 'actions/index.ts';
import ESignService from 'services/esign';
import useList from 'hooks/useList';

function StatementList(props) {
  const Config = {
    sale: {
      title: '客户对账单',
      apiPath: '/statementOrder/getPageList',
      orderProperty: 'createTime',
      arrEnumField: [
        { mainKey: 'B02_Reco_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Esign_Status',
          subKey: 'esignStatus',
          value: 'esignStatusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/billing/statement/detail',
      searchBarPlaceholder: '客户名称/编码、对账单号',
      tabs: ['全部', '待发送', '待确认', '已确认'],
      tabConfig: [
        undefined, //全部
        [0, 2, 4], //待发送
        [1, 6, 7], //待确认
        [5] //已确认
      ]
    },
    purchase: {
      title: '供应商对账单',
      apiPath: '/vStatementOrder/getPageList',
      orderProperty: 'createTime',
      //枚举列表
      arrEnumField: [
        { mainKey: 'B02_Reco_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Esign_Status',
          subKey: 'esignStatus',
          value: 'esignStatusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/billing/statement/detail',
      searchBarPlaceholder: '供应商名称/编码、对账单号',
      tabs: ['全部', '待发送', '待确认', '已确认', '待签章'],
      tabConfig: [
        undefined, //全部
        [0, 2, 4], //待发送
        [1, 6, 7], //待确认
        [5], //已确认
        [5] //待签章
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const [onlyCanApplyTransfer, setOnlyCanApplyTransfer] = useState(false);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
    //采购方
    if (self.isPurchase) {
      ESignService.getCount(companyCode, 4, true).then(rs => {
        count[4] = rs.esignCount;
      });
    }
  }, [companyCode, count, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, onlyCanApplyTransfer, self]);

  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        status: config.tabConfig[currentTab],
        isCanApply: onlyCanApplyTransfer ? 1 : undefined, //仅显示可转付款申请单据
        isESign: currentTab === 4 ? 1 : undefined //待签章
      };
    } else {
      self.searchQueries = {
        status: config.tabConfig[currentTab]
      };
    }
  };

  //仅显示可转付款申请单据
  function handleOnlyCanApply(event) {
    handleReset();
    setOnlyCanApplyTransfer(event.target.checked);
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {self.isPurchase && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={onlyCanApplyTransfer}
                      onChange={handleOnlyCanApply}
                      value="checkedA"
                      color="primary"
                    />
                  }
                  labelPlacement="start"
                  label="仅显示可转付款申请单据"
                />
              )} */}
              {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.recoXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.recoXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('reco', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>对账周期</label>
                          <div>
                            {formatDate(item.recoStartTime)} 至{' '}
                            {formatDate(item.recoEndTime)}
                          </div>
                        </li>
                        <li>
                          <label>对账含税金额</label>
                          <div>
                            {formatNumber(
                              item.totalConfirmTaxAmount,
                              item.Amount_Decimal_Place
                            )}
                          </div>
                        </li>
                        {!self.isPurchase && (
                          <li>
                            <label>冲预付金额</label>
                            <div>
                              {formatNumber(
                                item.prepayTotalAmount,
                                item.Amount_Decimal_Place
                              )}
                            </div>
                          </li>
                        )}
                        <li>
                          <label>
                            {self.isPurchase ? '应付金额' : '应收金额'}：
                          </label>
                          <div>
                            {formatNumber(
                              item.payTotalAmount,
                              item.Amount_Decimal_Place
                            )}
                          </div>
                        </li>
                        <li>
                          <label>签章状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                (item.esignStatus === 2 ? 'green' : '')
                              }
                            >
                              {item.esignStatusName}
                            </span>
                          </div>
                        </li>
                        <li>
                          <label>同步状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                (item.syncStatus === 2 ? 'green' : '')
                              }
                            >
                              {item.syncStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

StatementList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(StatementList);
